module.exports = __webpack_public_path__ + "static/img/goods04.94786abb.jpg";